// 主入口文件
import { PlatformFactory } from './src/core';
import { PlatformEnum } from './src/utils/types';
// 创建全局platform对象
const factory = PlatformFactory.getInstance();
const platform = factory.create();
// 导出platform对象
export { platform };
export default platform;
export { PlatformEnum };
// 工厂类
export { PlatformFactory } from './src/core/factory';
// 环境检测器
export { EnvironmentDetector } from './src/core/detector';
// 错误处理器
export { ErrorHandler } from './src/utils/error-handler';
// 适配器类
export { BaseAdapter } from './src/adapters/base';
export { WebAdapter } from './src/adapters/web';
export { LiteappAdapter } from './src/adapters/liteapp';
// 工具函数
export * from './src/utils/types';
// 便捷使用的工厂方法
export const createPlatform = () => PlatformFactory.getInstance().create();
export const getPlatformInfo = () => PlatformFactory.getInstance().getPlatformInfo();
export const resetPlatform = () => PlatformFactory.getInstance().reset();
export const forcePlatform = (platformType) => PlatformFactory.getInstance().forcePlatform(platformType);
export * from './src/types/index';
//# sourceMappingURL=index.js.map